module.exports = __webpack_public_path__ + "static/media/instrapiano.de53e3ab.svg";